const windowTs = window as { [key: string]: any };

export const environment = {
	apiUrl: windowTs['env']['API_URL'] || process.env.API_URL,
};
